"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectEventSchema = void 0;
const zod_1 = require("zod");
const project_1 = require("./project");
const learningTrackedEventSchema = zod_1.z.object({
    type: zod_1.z.literal("learning_tracked"),
    learning: zod_1.z.string(),
    source: zod_1.z.union([zod_1.z.object({ chatWithUser: zod_1.z.string() }), zod_1.z.object({ meeting: zod_1.z.string() })]),
});
const planUpdatedEventSchema = zod_1.z.object({
    type: zod_1.z.literal("plan_updated"),
    reason: zod_1.z.string(),
});
const projectStartedEventSchema = zod_1.z.object({
    type: zod_1.z.literal("project_started"),
});
const nextStepsUpdatedSchema = zod_1.z.object({
    type: zod_1.z.literal("next_steps_updated"),
});
const meetingScheduledEventSchema = zod_1.z.object({
    type: zod_1.z.literal("meeting_scheduled"),
    meetingId: zod_1.z.string(),
});
const meetingCompletedSummaryAvailableEventSchema = zod_1.z.object({
    type: zod_1.z.literal("meeting_completed_summary_available"),
    meetingId: zod_1.z.string(),
    meetingTitle: zod_1.z.string(),
});
const deliverableDeliveredEventSchema = zod_1.z.object({
    type: zod_1.z.literal("deliverable_delivered"),
    workstreamId: zod_1.z.string(),
    deliverableId: zod_1.z.string(),
});
const workstreamCompletedEventSchema = zod_1.z.object({
    type: zod_1.z.literal("workstream_completed"),
    workstreamId: zod_1.z.string(),
});
const workstreamStartedEventSchema = zod_1.z.object({
    type: zod_1.z.literal("workstream_started"),
    workstreamId: zod_1.z.string(),
});
const attachmentCreatedEventSchema = zod_1.z.object({
    type: zod_1.z.literal("attachment_created"),
    attachmentId: zod_1.z.string(),
});
const documentGeneratedEventSchema = zod_1.z.object({
    type: zod_1.z.literal("document_generated"),
    attachmentId: zod_1.z.string(),
    documentName: zod_1.z.string(),
});
const documentMarkedStaleEventSchema = zod_1.z.object({
    type: zod_1.z.literal("document_marked_stale"),
    attachmentId: zod_1.z.string(),
    reason: zod_1.z.string(),
});
const documentUpdateAppliedEventSchema = zod_1.z.object({
    type: zod_1.z.literal("document_update_applied"),
    attachmentId: zod_1.z.string(),
    changesApplied: zod_1.z.number(),
});
const taskStatusChangedEventSchema = zod_1.z.object({
    type: zod_1.z.literal("task_status_changed"),
    taskId: zod_1.z.string(),
    previousStatus: project_1.taskStatusSchema.nullable(),
    newStatus: project_1.taskStatusSchema.nullable(),
});
const projectOwnerChangedEventSchema = zod_1.z.object({
    type: zod_1.z.literal("project_owner_changed"),
    previousOwnerId: zod_1.z.string(),
    newOwnerId: zod_1.z.string(),
});
exports.projectEventSchema = zod_1.z.object({
    id: zod_1.z.string(),
    date: zod_1.z.string(),
    actor: zod_1.z.union([zod_1.z.object({ tekkr: zod_1.z.literal(true) }), zod_1.z.object({ userId: zod_1.z.string() })]),
    event: zod_1.z.discriminatedUnion("type", [
        learningTrackedEventSchema,
        planUpdatedEventSchema,
        nextStepsUpdatedSchema,
        meetingScheduledEventSchema,
        meetingCompletedSummaryAvailableEventSchema,
        projectStartedEventSchema,
        deliverableDeliveredEventSchema,
        workstreamCompletedEventSchema,
        workstreamStartedEventSchema,
        attachmentCreatedEventSchema,
        documentGeneratedEventSchema,
        documentMarkedStaleEventSchema,
        documentUpdateAppliedEventSchema,
        taskStatusChangedEventSchema,
        projectOwnerChangedEventSchema,
    ]),
});
